import React from "react";
import Nav from "../../layout/Navv/Nav";
import About from "../../layout/About/About";
import Headerr from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import Contact from "../../layout/Contact/Contact";
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";


const Home = () => {
	return (
		<div>
			<Headerr />
			<Nav />
			<About />
		{/* 	<Contact /> */}
			<Footer />
			<WhatsAppButton />
		</div>
	);
};

export default Home;
